<template>
  <div class="container">
    <div class="module_title">
      <span>培训管理 》培训课程</span>
      <div class="right">
        <img src="@/assets/imagestore_cloud_icon.png" alt="">
        <span style="margin-left: 10px;">
                    <label>最大存储:</label>
                    {{ ncitem.quota }}(MB)
                </span>
        <span style="margin-left: 10px;">
                    <label>已占用存储:</label>
                    {{ ncitem.size }}(MB)
                </span>
        <span style="margin-left: 10px;">
                    <label>剩余存储:</label>
                    {{ residue }}(MB)
                </span>
      </div>

    </div>

    <div class="operBox">
      <div class="left">
        <template v-if="activeName == 0">
                    <span class="xiaoshou" @click="oper('a1')">
                        <img src="@/assets/images/manage/course/cr_tools_new.png" alt="">
                        <span class="xiaosho margin_left_5 margin_top_2">创建</span>
                    </span>
          <span class="xiaoshou margin_left_10" @click="oper('a2')">
                        <img src="@/assets/images/manage/course/cr_tools_edit.png" alt="">
                        <span class="xiaosho margin_left_5 margin_top_2">编辑</span>
                    </span>
          <span class="xiaoshou margin_left_10" @click="oper('a3')">
                        <img src="@/assets/images/manage/course/cr_tools_save.png" alt="">
                        <span class="xiaosho margin_left_5 margin_top_2">保存</span>
                    </span>
          <span class="xiaoshou margin_left_10" @click="oper('a4')">
                        <img src="@/assets/imagestore_del_icon.png" alt="">
                        <span class="xiaosho margin_left_5 margin_top_2">删除</span>
                    </span>

          <span class="xiaoshou margin_left_10 before" @click="oper('a5')">
                        <img src="@/assets/images/manage/course/cr_tools_newdg.png" alt="">
                        <span class="xiaosho margin_left_5 margin_top_2">新建大纲</span>
                    </span>


        </template>
        <template v-else>
                    <span class="xiaoshou" @click="oper('b1')"><img src="@/assets/imagestore_upvdsfile_icon.png" alt="">
                        <span class="xiaosho margin_left_5 margin_top_2">添加课程</span>
                    </span>
          <span class="xiaoshou margin_left_10" @click="oper('b2')"><img
              src="@/assets/imagestore_downvdsfile_icon.png" alt="">
                        <span class="xiaosho margin_left_5 margin_top_2">下载课程</span>
                    </span>
          <span class="xiaoshou margin_left_10" @click="multiple = !multiple">
                        <img v-if="multiple" src="@/assets/vodstore_checked_icon.png" alt="">
                        <img v-else src="@/assets/vodstore_check_icon.png" alt="">
                        <span class="xiaosho margin_left_5 margin_top_2">课程选择</span>
                    </span>

          <span class="xiaoshou margin_left_10" @click="oper('b4')"><img src="@/assets/imagestore_del_icon.png"
                                                                        alt="">
                        <span class="xiaosho margin_left_5 margin_top_2">删除课程</span>
                    </span>
          <div class="search">
            <input type="text" placeholder="请输入课程名称..." v-model="postForm2.name">
            <div class="rightIco pointer" @click="getList2">
              <img src="@/assets/images/manage/course/cr_sousuo_blue.png" alt="">
              <!-- <i class="iconfont icon-sousuo3 size20"></i> -->
            </div>
          </div>
        </template>


      </div>
      <div class="rightBox padding_right_10">
        <span>选择企业：</span>
        <el-select v-model="postForm1.enterprise_id" placeholder="" style="width:200px">
          <el-option-group v-for="(group, index) in options" :key="index" :label="group.label">
            <el-option v-for="(item, index) in group.options" :key="index" :label="item.enterprise_name"
                       :value="item.enterprise_id">
            </el-option>
          </el-option-group>
        </el-select>
        <el-button type="primary" icon="el-icon-search" class="margin_left_10" @click="search">查询</el-button>
      </div>
    </div>

    <div class="content">
      <div class="left_list" :style="{ width: left_list_width }">
        <div class="left_list_title">
          <template v-if="leftFoldshow == true">
            <div>
              <span class="dot userzudot"></span>
              <span v-show="leftFoldshow == true">课程列表</span>
            </div>
            <i @click="foldshowclick('left')" class="el-icon-s-fold xiaosho" style="font-size: 20px;"></i>
          </template>
          <i v-else @click="foldshowclick('left')" class="el-icon-s-unfold xiaosho"
             style="font-size: 20px;flex: 1;"></i>

        </div>
        <div class="joblist" v-if="leftFoldshow">
          <template v-if="leftList.length > 0">
            <ul v-infinite-scroll="getList1" infinite-scroll-disabled="disabled">

              <li class="xiaosho list_item"
                  :class="{ 'list_item_active': left_list_value == item.outline_id }"
                  v-for="(item, index) in leftList" :key="index"
                  @click="listValueChange('left', index, item)">
                <p class="text_ellipsis">
                  {{ item.outline_name }}
                </p>
                <p class="text_ellipsis color7b7b7b size11">
                  {{ item.enterprise_name }}
                </p>

              </li>

            </ul>
            <p v-if="infinite_loading" style="text-align: center; padding: 10px 0;">加载中...</p>
            <p v-if="noMore" style="text-align: center; padding: 10px 0;">没有更多了</p>
          </template>
          <template v-else>
            <div class="empty">
                            <span>
                                暂无课程信息数据
                            </span>
            </div>
          </template>
        </div>

        <div class="joblist" v-else></div>
      </div>
      <div class="centerBox">
        <div class="centerTop">
          <div class="tabs">
            <div class="tabs__item" v-for="(item, index) in tabList" :key="index" @click="changeTab(item.value)"
                 :style="{
                                'border-bottom': activeName == item.value ? '1px solid #12618A' : 'none',
                            }">
                            <span>
                                {{ item.label }}
                            </span>
            </div>

          </div>
          <div class="foldBox" v-if="activeName == 1">
            <template v-if="modeActive == 'table'">
              <img :src="require('../../assets/interface_device_listhover_icon.png')" alt=""
                   class="actabimg"/>
              <img :src="require('../../assets/interface_device_viewnormal_icon.png')" alt=""
                   @click="modeChange('card')" class="actabimg" style="margin-left: 5px"/>

            </template>
            <template v-else>
              <img @click="modeChange('table')"
                   :src="require('../../assets/interface_device_listnormal_icon.png')" alt=""
                   class="actabimg"/>
              <img :src="require('../../assets/interface_device_viewhover_icon.png')" alt="" class="actabimg"
                   style="margin-left: 5px"/>
            </template>
          </div>
        </div>


        <div v-show="activeName == 0" class="data_list">

          <form1 ref="form1" v-if="showEditForm" @ok="ok('ok11')"></form1>
          <preview1 ref="preview1" v-else></preview1>
        </div>
        <div v-show="activeName == 1" class="data_list" v-loading="loading">
          <div v-if="modeActive == 'table'" class="table_box">
            <template>
              <el-table :data="tableData" row-key="code" border lazy :stripe="true"
                        :highlight-current-row="true" :header-cell-style="{ background: '#eee', color: '#606266' }"
                        v-loading="loading" element-loading-background="#fff" element-loading-text="数据正在加载中"
                        element-loading-spinner="el-icon-loading" ref="refTable" :height="'calc(100% - 45px)'"
                        @selection-change="handleSelectionChange" @cell-click="cenjiclick">
                <el-table-column type="selection" width="55"></el-table-column>
                <!-- <el-table-column prop="enterprise_name" label="图片编号" min-width="155"
:show-overflow-tooltip="true"></el-table-column> -->
                <el-table-column prop="name" label="课程名称" :show-overflow-tooltip="true">
                  <template v-slot="{ row }">
                    <div style=" white-space: nowrap;">
                      <el-link :underline="false">{{ row.name }}</el-link>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="intro" label="简介" width="160" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="enterprise_name" label="发布单位" width="100"
                                 :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="utime_str" label="创建时间"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="audit_time_str" label="审核时间"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="audit_state" label="审核结果" width="100" :show-overflow-tooltip="true">
                  <template v-slot="{ row }">
                    <div style="white-space: nowrap;">
                      <span v-show="row.audit_state == '1'">待审核</span>
                      <span v-show="row.audit_state == '2'">已通过</span>
                      <span v-show="row.audit_state == '3'">未通过</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="price" label="价格" width="100"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="credits" label="学分" width="80"
                                 :show-overflow-tooltip="true"></el-table-column>
                <!--                                <el-table-column prop="file_name" label="文件名称" width="100"-->
                <!--                                    :show-overflow-tooltip="true"></el-table-column>-->
                <!-- <el-table-column label="是否锁定" width="80" :show-overflow-tooltip="true">
            <template v-slot="{ row }">
                <div style="white-space: nowrap;">
                    <span v-show="row.lock == true">是</span>
                    <span v-show="row.lock == false">否</span>
                </div>
            </template>
        </el-table-column> -->
                <el-table-column width="200" fixed="right" label="操作">
                  <template slot-scope="scope">
                    <div style=" white-space: nowrap;">
                      <el-button @click="tableOper('edit', scope.row)" type="text"
                                 size="small">编辑
                      </el-button>
                      <el-button @click="tableOper('see', scope.row)" type="text"
                                 size="small">查看
                      </el-button>
                      <el-button @click="tableOper('del', scope.row)" type="text"
                                 size="small">删除
                      </el-button>
                      <el-button  @click="previewVideo(scope.row)" type="text"
                                 size="small">视频
                      </el-button>
                      <el-button v-show="scope.row.lock == false && scope.row.dir == false"
                                 @click="lock(scope.row, true)" type="text" size="small">锁定
                      </el-button>
                      <el-button v-show="scope.row.lock == true && scope.row.dir == false"
                                 @click="lock(scope.row, false)" type="text" size="small">解锁
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                  class="pagination"
                  background @size-change="handleSizeChange"
                  @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30]"
                  :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total">
              </el-pagination>
            </template>
          </div>

          <template v-else>
            <template v-if="tableData.length > 0 && loading == false">

              <div class="checkboxGroup">

                <el-popover class="recordBox pointer" placement="bottom-start"
                            v-for="(item, index) in tableData" :key="item.id" trigger="hover">
                  <popver :object="item"></popver>
                  <div slot="reference" class="record">
                    <div class="left">
                      <el-checkbox v-model="item.checked" v-if="multiple"
                                   @change="checkChange(item)"></el-checkbox>
                    </div>
                    <div class="right">
                      <div class="videoBox" @click="previewVideo(item)">
                        <img :src="$imgUrl(item.cover)" alt=""/>

                        <div class="play"></div>
                      </div>
                      <div class="imgName text_ellipsis">

                        {{ item.name }}
                      </div>
                    </div>


                  </div>

                </el-popover>
              </div>


            </template>

            <template v-if="tableData.length == 0 && loading == false">
              <el-empty description="暂无数据" class="empty"></el-empty>
            </template>
          </template>

        </div>
      </div>
      <div class="right_list" :style="{ width: right_list_width }">
        <div class="right_list_title">
          <template v-if="rightFoldshow == true">
            <i @click="foldshowclick('right')" class="el-icon-s-unfold xiaosho" style="font-size: 20px;"></i>
            <div class="margin_left_10">
              <!-- <span class="dot userzudot"></span> -->
              <span v-show="rightFoldshow == true">课程大纲</span>
            </div>

          </template>
          <i v-else @click="foldshowclick('right')" class="el-icon-s-fold xiaosho" style="font-size: 20px;"></i>


        </div>
        <ul class="joblist" v-if="rightFoldshow">
          <template v-if="rightList.length > 0">
            <li class="list_item" v-for="(item, index) in rightList" :key="index"
                @click="listValueChange('right', index, item)">
              <div class="parent">
                <div class="left" >
                  <div class="ico" :class="{
                                        'pointer': item.children && item.children.length
                                    }" @click="item.fold = !item.fold">
                    <el-tooltip v-if="item.children && item.children.length" class="item" effect="dark"
                                :content="item.fold ? '展开' : '收起'" placement="top">
                      <i class="el-icon-plus" v-if="item.fold"></i>
                      <i class="el-icon-minus" v-else></i>
                    </el-tooltip>
                  </div>
                  <div class="content">
                    <div class="title text_ellipsis font_weight_600 pointer" @click="changeContents(item)">
                      <span>{{ item.contents_name }}</span>
                    </div>
                    <div class="ico margin_left_5">
                      <i class="iconfont icon-yunhang1 color_green" v-if="item.video_flag == '1'"></i>
                    </div>
                  </div>
                </div>
                <div class="right">
                  <div class="ico" @click="oper('a5', item, true)">
                    <el-tooltip class="item" effect="dark" content="创建子大纲" placement="top">
                      <i class="el-icon-plus"></i>
                    </el-tooltip>
                  </div>
                  <div class="ico" @click="treeOper('del', item)">
                    <el-tooltip class="item" effect="dark" content="删除大纲" placement="top">
                      <i class="el-icon-minus"></i>
                    </el-tooltip>
                  </div>
                  <div class="ico" @click="treeOper('sort', item, 'up')">
                    <el-tooltip class="item" effect="dark" content="上移" placement="top">
                      <i class="el-icon-arrow-up"></i>
                    </el-tooltip>
                  </div>
                  <div class="ico" @click="treeOper('sort', item, 'down')">
                    <el-tooltip class="item" effect="dark" content="下移" placement="top">
                      <i class="el-icon-arrow-down"></i>
                    </el-tooltip>

                  </div>
                </div>
              </div>
              <template v-if="!item.fold">
                <div class="child" v-for="(item, index) in item.children" :key="index">
                  <div class="left" >
                    <div class="content">
                      <div class="title text_ellipsis pointer" @click="changeContents(item)">
                        <span>{{ item.contents_name }}</span>

                      </div>
                      <div class="ico margin_left_5">
                        <i class="iconfont icon-yunhang1 color_green"
                           v-if="item.video_flag == '1'"></i>
                      </div>
                    </div>
                  </div>
                  <div class="right">

                    <div class="ico">
                      <el-tooltip class="item" effect="dark" content="删除子大纲" placement="top">
                        <i class="el-icon-minus"></i>
                      </el-tooltip>
                    </div>
                    <div class="ico" @click="treeOper('sort', item, 'up')">
                      <el-tooltip class="item" effect="dark" content="上移" placement="top">
                        <i class="el-icon-arrow-up"></i>
                      </el-tooltip>
                    </div>
                    <div class="ico" @click="treeOper('sort', item, 'down')">
                      <el-tooltip class="item" effect="dark" content="下移" placement="top">
                        <i class="el-icon-arrow-down"></i>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </template>
            </li>

          </template>
          <template v-else>
            <div class="empty">
                            <span>
                                暂无课程大纲数据
                            </span>
            </div>
          </template>
        </ul>
        <div class="joblist" v-else></div>
      </div>

    </div>
    <el-dialog v-dialogDrag :title="myaddtitle" :visible.sync="dialogFormVisibles.val" width="550px" top="200px"
               :modal-append-to-body="false" v-if="dialogFormVisibles.val">
      <!-- v-if  从新渲染 -->
      <trainingCourseAdd v-if="dialogFormVisibles.val" :dialogFormVisibles="dialogFormVisibles"
                         v-on:loadTable="fileslist" v-on:loadTable1="cenjiclick" :layerType="myaddtype"
                         :mydata="viewdata">
      </trainingCourseAdd>
    </el-dialog>
    <previewVideo ref="previewVideo"></previewVideo>
    <dialogForm1 :id="1" ref="dialogForm1" @ok="ok('ok1')"></dialogForm1>
    <dialogForm2 :id="1" ref="dialogForm2" @ok="ok('ok2')"></dialogForm2>
    <dialogForm3 :videoInfo="videoInfo" ref="dialogForm3" @ok="ok('ok3')"></dialogForm3>
  </div>
</template>
<script>
import "../common/common.css"
import preview1 from './components/preview1.vue'
import previewVideo from './components/previewVideo.vue'
import dialogForm1 from './components/dialogForm1.vue'//课程
import dialogForm2 from './components/dialogForm2.vue'//大纲
import dialogForm3 from './components/dialogForm3.vue'//视频

import form1 from './components/form1.vue'
import popver from './components/popver.vue'
import trainingCourseAdd from './components/add.vue'

export default {
  components: {
    preview1,
    previewVideo,
    dialogForm1,
    dialogForm3,
    dialogForm2,
    form1,
    popver,
    "trainingCourseAdd": trainingCourseAdd,
  },
  computed: {
    noMore() {
      return this.leftList.length >= this.leftListTotal && !this.infinite_loading
    },
    disabled() {
      return this.infinite_loading || this.noMore
    }
  },
  data() {
    return {
      options: JSON.parse(localStorage.getItem('entinfolist')),
      ncitem: {},//存储
      residue: '',
      infinite_loading: false,
      leftListTotal: 0,
      leftListCurrentPage: 0,
      leftListPagesize: 10,
      leftList: [],
      left_list_width: '240px',
      leftFoldshow: true,
      left_list_value: '',
      rightList: [],
      right_list_width: '375px',
      rightFoldshow: true,
      right_list_value: '',

      tabList: [
        {
          label: '课程信息',
          value: '0'
        },
        {
          label: '课程视频',
          value: '1'
        },
      ],
      showEditForm: false,//课程信息是否展示编辑表单
      // 上方操作
      multiple: false,
      // 列表上方tab
      activeName: '0',
      // 列表形式
      modeActive: 'card',
      // 左侧列表参数
      postForm1: {
        page: 1,
        limit: 10,
        "outline_name": "",//名称
        "enterprise_id": localStorage.getItem('enterprise_id'),//企业唯一标识
      },
      // 中间列表参数
      postForm2: {
        page: 1,
        limit: 10,
        "name": "",//视频课程名称
        "outline_id": "",//主课程详情 ID
        "contents_id": "",//课程大纲目录 ID
        "enterprise_id": localStorage.getItem('enterprise_id'),//企业唯一标识
      },
      // 右侧列表参数
      postForm3: {
        "outline_id": "",//主课程详情 ID
        //"contents_name": "",//名称
        // page: 1,
        // limit: 10,
        // "course_name": "",//课程完整名称
        // "recruitment_id": "",//关联的职位 / 招聘 ID
        // "enterprise_id": "",//企业唯一标识
      },
      // 分页
      pagesize: 10,
      currentPage: 1,
      total: 0,
      loading: false,
      // 课程视频选择
      checkList: [],
      // 表格数据
      tableData: [],
      animate: false,
      timie: null,
      datadel: [],
      dialogFormVisibles: {val: false},
      items: [{name: "收到人脸设备（位置：北京大学东门入口点，设备编号：AICR-200120）注册数剧等等"},
        {name: "收到人脸设备（位置：北京大学东门入口点，设备编号：AICR-200122）注册数剧等等"},
        {name: "收到人脸设备（位置：北京大学东门入口点，设备编号：AICR-200123）注册数剧等等"}],
      // 添加课程默认信息
      videoInfo: {},//视频信息


      // state: '',
      // selectedItem: '1',
      // tablewidth: '195px',
      // tabmaxheight: window.innerHeight - 254,
      // treewidth: window.innerWidth - 288 + 'px',
      // tableData: [],
      // leftFoldshow: true,
      // ncitem: {},
      // residue: '',
      // leftStatus: 0,
      // treedata: [],
      // currentNodekey: '',
      // defaultProps: {
      //     children: 'sub',
      //     label: 'name'
      // },
      // mydata: {},
      // myaddtype: '',
      // myaddtitle: '',
      // viewdata: '',
      // imgshow: false,
      // enterprise_id: '',
      // multipleshow: false,
      // checkboxshow: false,

      // path: '/data',
      // clearshow: false,
      // page: 1,
      // previewsrc: '',
      // previewVisible: false,
      // tableData1: [],
      // wjpath: '',
      // pathcj: 0,
      // option1: [],
      // option2: [],
    };
  },
  created() {
    // this.getRecruitmentlist()
    this.enterprise_id = localStorage.getItem('enterprise_id')
    this.getList1(true)
    this.filesinfo()

  },
  mounted() {
    // this.filesinfo()

    // this.timie = setInterval(this.scroll, 2000)
  },
  watch: {
    multipleshow(old, mul) {
      if (old == true) {
        this.checkboxshow = true
      } else {
        this.checkboxshow = false
      }
    },
    selectedItem(old, xing) {
      if (old == 2) {
        this.$refs["select"].$el.children[0].children[0].setAttribute(
            "style",
            "background:url(" + require("../../assets/imagestore_block_icon.png") + ") no-repeat;background-position: 9% center;padding-left:40px;background-size:15%"
        );
        this.imgshow = true
        if (this.path == '/video') {
          this.generateThumbnails()
        }
      } else {
        this.$refs["select"].$el.children[0].children[0].setAttribute(
            "style",
            "background:url(" + require("../../assets/imagestore_list_icon.png") + ") no-repeat;background-position: 9% center;padding-left:40px;background-size:15%"
        );
        this.imgshow = false
      }
    },

  },
  methods: {
    // 选择企业改变
    search() {
      // console.log(value);
      // this.postForm1.enterprise_id = value
      this.activeName = '0'

      this.postForm2.enterprise_id = this.postForm1.enterprise_id

      this.getList1(true)
      // 如果tab在视频课程，则重新获取视频课程
      // if (this.activeName == '1') {
      //     this.currentPage=1
      //     this.getList2()
      // }
    },

    // 获取职位
    getRecruitmentlist() {
      this.$tools
          .asyncPost(this, this.$baseUrl.hrrecruitmentlist, {
            data: this.queryParam
          })
          .then(res => {
            if (res.data.code == 0) {
              // 在res.data.data.data数组前面推入一个全部的数据
              res.data.data.data.unshift({
                id: '0',
                recruitment_id: '',
                position_name: '全部',
              })
              this.leftList = res.data.data.data
            } else {
              this.$message({showClose: true, type: "error", message: res.data.msg});
            }
          })
          .catch(err => {
          });
    },
    //操作按钮
    oper(type, item, disabled) {
      // 如果左侧未有课程，提示示先创建课程
      if (!this.left_list_value && type != 'a1') {
        this.$message({showClose: true, type: "warning", message: '请先创建课程'});
        return
      }
      switch (type) {
          // 创建
        case 'a1':
          this.$refs.dialogForm1.dialogVisible = true
          this.$refs.dialogForm1.init()
          break;
          // 编辑
        case 'a2':
          this.showEditForm = true
          this.$nextTick(() => {
            this.$refs.form1.getData(this.left_list_value)
          })


          break;
          // 保存
        case 'a3':
          if (!this.showEditForm) {
            return
          }
          // 询问是否保存
          this.$MessageBox.confirm("确定保存吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.$refs.form1 && this.$refs.form1.handleOk()
          }).catch(() => {
            this.showEditForm = false
            this.$nextTick(() => {
              this.$refs.preview1.getData(this.left_list_value)
            })
          });


          break;
          // 删除课程
        case 'a4':
          this.$MessageBox.confirm("确定删除吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.$tools
                .asyncPost(
                    this,
                    this.$baseUrl.trainingCourseDel, {
                      data: {
                        ids: [this.left_list_value]
                      }
                    }).then((res) => {
              if (res.data.code == 0) {
                this.$message({type: "success", message: '删除成功'});
                this.left_list_value = ''
                // 重新渲染左侧列表

                this.getList1(true)

              } else {
                this.$message({type: "error", message: res.data.msg});
              }
              this.loading = false;
            }).catch((err) => {
              this.loading = false;
            });
          }).catch(() => {

          });
          break;
          // 创建大纲
        case 'a5':
          this.$refs.dialogForm2.dialogVisible = true

          this.$refs.dialogForm2.init(this.left_list_value)
          // 如果是新建子大纲，给父id赋值，并且禁用

          if (disabled) {
            this.$refs.dialogForm2.disabled = true
            this.$refs.dialogForm2.ruleForm.parent_contents_id = item.contents_id
          } else {
            this.$refs.dialogForm2.disabled = false
          }

          break;
          // 添加课程
        case 'b1':
          this.$refs.dialogForm3.dialogVisible = true
          this.$refs.dialogForm3.init(this.videoInfo)
          break;
          // 下载视频
        case 'b2':
          this.checkList.forEach(item => {
            const link = document.createElement('a');
            link.href = this.$imgUrl(item.file_name);
            link.download = item.name.substring(item.name.lastIndexOf('/') + 1);
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          break;
          // 删除视频
        case 'b4':
          if (!this.checkList.length) {
            return this.$message({showClose: true, type: "warning", message: '请选择视频'});
          }
          this.$MessageBox.confirm("确定删除吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.$tools
                .asyncPost(
                    this,
                    this.$baseUrl.trainingCourseVideoDel, {
                      data: {
                        ids: this.checkList.map(item => {
                          return item.id
                        })
                      }
                    }).then((res) => {
              if (res.data.code == 0) {
                this.$message({type: "success", message: '删除成功'});
                this.checkList = []
                // 重新渲染左侧列表
                this.currentPage = 1
                this.getList2()

              } else {
                this.$message({type: "error", message: res.data.msg});
              }
              this.loading = false;
            }).catch((err) => {
              this.loading = false;
            });
          }).catch(() => {

          });
          break;

        default:
          break;
      }
    },
    // 表格操作按钮
    tableOper(type, item) {
      switch (type) {
        case 'edit':

          this.$refs.dialogForm3.dialogVisible = true
          this.$refs.dialogForm3.init(item, true)
          break;
        case 'see':
          this.$refs.dialogForm3.dialogVisible = true
          this.$refs.dialogForm3.see(item)
          break;
        case 'del':
          this.$MessageBox.confirm("确定删除吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.$tools
                .asyncPost(
                    this,
                    this.$baseUrl.trainingCourseVideoDel, {
                      data: {
                        ids: [item.id]
                      }
                    }).then((res) => {
              if (res.data.code == 0) {
                this.$message({type: "success", message: '删除成功'});
                this.checkList = this.checkList.filter((i) => i.id != item.id)
                // 重新渲染左侧列表
                this.currentPage = 1
                this.getList2()

              } else {
                this.$message({type: "error", message: res.data.msg});
              }
              this.loading = false;
            }).catch((err) => {
              this.loading = false;
            });
          }).catch(() => {

          });
          break;
        default:
          break;
      }
    },
    //右侧树操作按钮
    treeOper(type, item, type2) {
      switch (type) {
        case 'del':
          this.$MessageBox.confirm("确定删除吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.$tools
                .asyncPost(
                    this,
                    this.$baseUrl.trainingOutlineDel, {
                      data: {
                        ids: [item.contents_id]
                      }
                    }).then((res) => {
              if (res.data.code == 0) {
                this.$message({type: "success", message: '删除成功'});
                // 重新渲染右侧列表

                this.getList3()

              } else {
                this.$message({type: "error", message: res.data.msg});
              }
            })
          })
          break;
        case 'sort':
          this.$tools
              .asyncPost(
                  this,
                  this.$baseUrl.trainingOutlineEditSort, {
                    data: {
                      contents_id: item.contents_id,
                      "sort_type": type2
                    }
                  }).then((res) => {
            if (res.data.code == 0) {
              this.$message({type: "success", message: '排序成功'});
              // 重新渲染右侧列表

              this.getList3()

            } else {
              this.$message({type: "error", message: res.data.msg});
            }
          })
          break;

        default:
          break;
      }
    },
    // 视频预览
    previewVideo(item) {
      this.$refs.previewVideo.dialogVisible = true;
      this.$refs.previewVideo.init(item);

    },
    // 成功传递
    ok(type, obj) {

      switch (type) {
          // 保存课程
        case 'ok1':
          this.leftListCurrentPage = 0
          this.getList1(false, true, true)
          break;
          // 保存新建大纲
        case 'ok2':
          this.getList3()
          break;
          // 保存课程视频
        case 'ok3':
          this.currentPage = 1
          this.getList2()
          break;
          // 更新课程
        case 'ok11':
          this.leftListCurrentPage = 0
          this.getList1(false, true)
          this.showEditForm = false
          this.$nextTick(() => {
            this.$refs.preview1.getData(this.left_list_value)
          })
          break;
        default:
          break;
      }
    },
    changeTab(value) {
      this.activeName = value;
      switch (value) {
        case '0':
          this.showEditForm = false
          this.$nextTick(() => {
            this.$refs.preview1.getData(this.left_list_value)
          })
          break;
        case '1':
          this.currentPage = 1
          this.$nextTick(() => {
            this.getList2()
          })
          break;
        default:
          break;
      }
      // if (value == 0) {
      //     this.path = '/data'
      //     this.cenjiclick('')
      //     this.bycodelist('DM-IMG-TPSCGS', 1)
      //     this.bycodelist('DM-VIDEO-SPSCGS', 2)
      // } else if (value == 1) {
      //     this.path = '/pic'
      //     this.fileslist()
      // } else {
      //     this.path = '/video'
      //     this.fileslist()
      // }
      // this.tableData = []
      // this.mydata.path = this.path
    },
    // 列表显示形式修改
    modeChange(type) {
      this.checkList = []
      this.modeActive = type;
    },
    // 多选框事件
    checkChange(item) {
      if (item.checked) {
        this.checkList.push(item)
      } else {
        this.checkList = this.checkList.filter((i) => {
          return (i.id != item.id)
        })
      }
      console.log(this.checkList);
    },
    // 左右列表点击收缩
    foldshowclick(type) {
      this[type + 'Foldshow'] = !this[type + 'Foldshow'];
      switch (this[type + 'Foldshow']) {
        case true:
          this[type + '_list_width'] = type == "left" ? "240px" : "400px";

          break;
        case false:

          this[type + '_list_width'] = "35px";
          break;
      }
    },
    // 左右列表点击
    listValueChange(type, index, item) {
      switch (type) {
        case 'left':
          this[type + '_list_value'] = item.outline_id;
          // 给添加视频课程赋值
          this.videoInfo = item
          this.getList3()
          this.showEditForm = false
          // 判断tab是否为视频
          // if (this.activeName == '1') {
          //     this.currentPage = 1
          //     this.getList2()
          // } else {
          this.activeName = '0'
          this.postForm2.contents_id=''
          this.$nextTick(() => {
            this.$refs.preview1.getData(this.left_list_value)
          })
          // }


          break;

        default:
          break;
      }

    },
    // 左侧列表@init是否初始化，@update是否更新，@add是否是更新中的添加
    getList1(init, update, add) {
      if (init) {
        this.showEditForm = false
        this.leftListCurrentPage = 0
      } else {
        // 如果是新增，新增完之后要进到编辑页面
        if (add) {
          this.showEditForm = true
        }
      }
      this.infinite_loading = true;
      this.leftListCurrentPage++
      this.postForm1.page = this.leftListCurrentPage
      this.postForm1.limit = this.leftListPagesize


      this.$tools
          .asyncPost(
              this,
              this.$baseUrl.trainingCourseList, {
                data: this.postForm1
              }).then((res) => {
        if (res.data.code == 0) {
          if (init || update) {
            this.leftList = res.data.data.data
          } else {
            let arr = this.leftList.concat(res.data.data.data)
            this.leftList = arr
          }

          if (init || add) {
            if (init) {
              if (this.leftList.length > 0) {
                this.left_list_value = this.leftList[0].outline_id
                // 给添加视频课程赋值
                this.videoInfo = this.leftList[0]
                this.$nextTick(() => {
                  this.$refs.preview1.getData(this.left_list_value)
                })
                // 获取右侧大纲树
                this.getList3()
              } else {
                this.left_list_value = ''
                this.videoInfo = {}
                this.$nextTick(() => {
                  this.$refs.preview1.getData(this.left_list_value)
                })

                // 获取右侧大纲树
                this.getList3()
              }
            } else {
              // 如果是新增，新增完之后要进到编辑页面
              this.left_list_value = this.leftList[0].outline_id
              // 给添加视频课程赋值
              this.videoInfo = this.leftList[0]
              this.$nextTick(() => {
                this.$refs.form1.getData(this.left_list_value)
              })
              // 获取右侧大纲树
              this.getList3()
            }


          }
          this.leftListTotal = res.data.data.total

        } else {
          this.$message({type: "error", message: res.data.msg});
        }
        this.infinite_loading = false;
      }).catch((err) => {
        this.loading = false;
      });
    },
    // 中间列表数据
    getList2() {
      this.tableData = []
      this.loading = true;
      this.postForm2.page = this.currentPage
      this.postForm2.limit = this.pagesize
      this.postForm2.outline_id = this.left_list_value
      if (!this.postForm2.outline_id) {
        this.loading = false;
        return
      }
      this.$tools
          .asyncPost(
              this,
              this.$baseUrl.trainingCourseVideoList, {
                data: this.postForm2
              }).then((res) => {
        if (res.data.code == 0) {

          this.tableData = res.data.data.data

          this.total = res.data.data.total
        } else {
          this.$message({type: "error", message: res.data.msg});
        }
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
      });
    },
    // 右侧列表
    getList3() {
      this.rightList = []
      // this.loading = true;
      // this.postForm3.page = this.currentPage
      // this.postForm3.limit = this.pagesize
      this.postForm3.outline_id = this.left_list_value
      if (!this.postForm3.outline_id) {
        this.loading = false;
        return
      }
      this.$tools
          .asyncPost(
              this,
              this.$baseUrl.trainingOutlineTree, {
                data: this.postForm3
              }).then((res) => {
        if (res.data.code == 0) {
          if (res.data.data && res.data.data.length > 0) {
            res.data.data.forEach(item => {
              item.fold = true
            })
            this.rightList = res.data.data
          } else {
            this.rightList = []
          }


        } else {
          this.$message({type: "error", message: res.data.msg});
        }
        // this.loading = false;
      }).catch((err) => {
        // this.loading = false;
      });
    },
    bycodelist(code, type) {
      this.$tools
          .asyncPost(this, this.$baseUrl.dictinfogetbycode, {
            data: {
              "dictionary_code": code
            }
          })
          .then((res) => {
            if (res.data.code == 0) {
              var str = []
              res.data.data.dictionary_detail.forEach(element => {
                str.push(element.dictionary_value)
              });
              switch (type) {
                case 1:
                  this.option1 = str
                  break;
                case 2:
                  this.option2 = str
                  break;
                default:
                  break;
              }
            } else {
              this.$message({type: "error", message: res.data.msg});
            }
          })
          .catch((err) => {
          })
    },
    pathfh() {
      var row = {
        dir: true,
        fh: true,
        name
      }
      var str = this.wjpath.split('/');
      var level = str.length - 2;
      if (level > 0) {
        row.name = str.slice(0, level).join('/')
      }
      this.cenjiclick(row)
    },
    cenjiclick(row, column) {
      if (row != '' || column != '') {
        if (column != undefined) {
          if (row != '' && column.property != "name") {
            return
          }
        }
        if (row.dir != true && row != '') {
          return
        }
        if (row.name != undefined && row.name != '') {
          if (row.fh) {
            this.wjpath = []
          }
          this.wjpath = this.wjpath + row.name + '/'
        } else {
          this.wjpath = '/'
        }
      }
      this.mydata.path = this.wjpath
      this.loading = true;
      this.$tools
          .asyncPost(this, this.$baseUrl.fileslist, {
            data: {
              bucket: localStorage.getItem('enterprise_id'),
              path: this.wjpath,
              page: this.currentPage,
              limit: 100,
            }
          })
          .then((res) => {
            if (res.data.code == 0) {
              var str = []
              res.data.data.files.forEach((item, index) => {
                if (item.dir == false) {
                  item.size = this.getSize(item.size)
                  this.$set(item, 'imgtype', item.name.split('.').pop())
                  str.push(item)
                } else {
                  str.push(item)
                }
              })
              this.tableData1 = str
              this.total = str.length;
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
              });
            }
            this.loading = false;
          })
          .catch((data) => {

          });
    },

    generateThumbnails() {
      const videoElements = document.querySelectorAll("video");
      videoElements.forEach((video, index) => {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        this.tableData[index].thumbnail = canvas.toDataURL("image/jpeg");
      });
    },
    getSize(size) {
      const units = ['B', 'KB', 'MB', 'GB'];
      let index = 0;
      while (size >= 1024 && index < units.length - 1) {
        size /= 1024;
        index++;
      }
      return size.toFixed(2) + units[index];
    },
    slicedName(item) {
      return item.name.slice(0, 3) + '...' + item.name.slice(item.name.indexOf('.') - 3, item.name.length);
    },
    upimg(type) {
      if (type == 1) {
        this.myaddtype = '/pic'
        this.myaddtitle = '上传图片'
      } else if (type == 2) {
        this.myaddtype = '/video'
        this.myaddtitle = '上传视频'
      } else {
        this.myaddtype = '/data'
        this.myaddtitle = '上传文件'
      }
      this.viewdata = this.mydata
      this.dialogFormVisibles.val = true
    },
    imgview(item) {
      if (this.path == '/pic') {
        this.myaddtype = 'viewpic'
      } else if (this.path == '/data') {
        if (this.option1.includes(item.imgtype)) {
          this.myaddtype = 'viewpic'
        } else if (this.option2.includes(item.imgtype)) {
          this.myaddtype = 'viewvideo'
        }
      } else {
        this.myaddtype = 'viewvideo'
      }
      this.myaddtitle = '查看'
      if (this.path == '/data') {
        this.viewdata = this.$baseUrl.files + '/' + this.enterprise_id + this.mydata.path + item.name
      } else {
        this.viewdata = this.$baseUrl.files + '/' + this.enterprise_id + this.mydata.path + '/' + item.name
      }
      this.dialogFormVisibles.val = true
    },
    lock(row, type) {
      var paths
      if (this.path == '/data') {
        paths = Array(this.mydata.path + row.name)
      } else {
        paths = Array(this.mydata.path + '/' + row.name)
      }
      if (type) {
        this.$tools
            .asyncPost(this, this.$baseUrl.fileslock, {
              data: {
                bucket: localStorage.getItem('enterprise_id'),
                paths: paths
              }
            })
            .then((res) => {
              if (res.data.code == 0) {
                if (this.path == '/data') {
                  this.cenjiclick('', '')
                } else {
                  this.permisdatil(this.mydata);
                }
                this.$message({type: "success", message: res.data.msg});
              } else {
                this.$message({type: "error", message: res.data.msg});
              }
            })
            .catch(() => {
            });
      } else {
        this.$tools
            .asyncPost(this, this.$baseUrl.filesulock, {
              data: {
                bucket: localStorage.getItem('enterprise_id'),
                paths: paths
              }
            })
            .then((res) => {
              if (res.data.code == 0) {
                if (this.path == '/data') {
                  this.cenjiclick('', '')
                } else {
                  this.permisdatil(this.mydata);
                }
                this.$message({type: "success", message: res.data.msg});
              } else {
                this.$message({type: "error", message: res.data.msg});
              }
            })
            .catch(() => {
            });
      }

    },
    circle() {
      this.state = ''
      this.permisdatil(this.mydata)
    },
    downimg() {
      this.checkList.forEach((item) => {
        const link = document.createElement('a');
        link.href = this.$baseUrl.files + '/' + this.enterprise_id + this.mydata.path + '/' + item.name;
        link.download = item.name.substring(item.name.lastIndexOf('/') + 1);
        link.target = '_blank';
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    handleSelectionclick(event) {
      if (event.checkend == true) {
        this.checkList.push(event)
      }
    },
    handleSelectionChange(val) {
      this.checkList = val
    },
    del(row) {
      if (row.lock == true) {
        this.$message({type: "error", message: '当前文件已锁定，不允许删除...'});
      } else {
        var str = []
        if (row.name != undefined) {
          if (this.mydata.path[this.mydata.path.length - 1] != '/') {
            str.push(this.mydata.path + '/' + row.name)
          } else {
            if (row.dir == true) {
              str.push(this.mydata.path + row.name + '/')
            } else {
              str.push(this.mydata.path + row.name)
            }
          }
        } else {
          if (this.checkList.length != 0) {
            this.checkList.forEach((item, index) => {
              if (this.mydata.path[this.mydata.path.length - 1] != '/') {
                str.push(this.mydata.path + '/' + item.name)
              } else {
                if (item.dir == true) {
                  str.push(this.mydata.path + item.name + '/')
                } else {
                  str.push(this.mydata.path + item.name)
                }
              }
            });
          } else {
            if (this.path == '/pic') {
              this.$message({type: "error", message: '请选择要删除的图片'});
            } else if (this.path == '/video') {
              this.$message({type: "error", message: '请选择要删除的视频'});
            } else {
              this.$message({type: "error", message: '请选择要删除的文件'});
            }
            return
          }
        }
        var messagebox = ''
        if (this.path == '/pic') {
          messagebox = '此操作将删除该图片, 是否继续?'
        } else if (this.path == '/video') {
          messagebox = '此操作将删除该视频, 是否继续?'
        } else {
          messagebox = '此操作将删除该文件, 是否继续?'
        }
        this.$MessageBox.confirm(messagebox, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          this.$tools
              .asyncPost(this, this.$baseUrl.filesdel, {
                data: {
                  bucket: localStorage.getItem('enterprise_id'),
                  paths: str
                }
              })
              .then((res) => {
                if (res.data.code == 0) {
                  this.$message({type: "success", message: res.data.msg});
                  if (this.path == '/data') {
                    var str = {
                      dir: true,
                      name: this.mydata.path.slice(0, this.mydata.path.length - 1)
                    }
                    this.cenjiclick('', '')
                  } else {
                    this.permisdatil(this.mydata);
                  }
                } else {
                  this.$message({type: "error", message: res.data.msg});
                }
              })
              .catch(() => {
              });
        }).catch(() => {
        });
      }
    },
    dirdel() {
      this.$MessageBox.confirm('此操作将删除该目录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.$tools
            .asyncPost(this, this.$baseUrl.filesepdel, {
              data: {
                bucket: localStorage.getItem('enterprise_id'),
                id: this.mydata.id
              }
            })
            .then((res) => {
              if (res.data.code == 0) {
                this.$message({type: "success", message: '删除成功'});
                this.fileslist();
              } else {
                this.$message({type: "error", message: res.data.msg});
              }

            })
            .catch(() => {
            });
      }).catch(() => {
      });
    },
    diradd() {
      this.myaddtype = 'add'
      this.myaddtitle = '新建目录'
      this.$set(this.mydata, 'pathtype', this.path)
      this.viewdata = this.mydata
      this.dialogFormVisibles.val = true
    },
    querySearchAsync(queryString, cb) {
      this.$tools
          .asyncPost(this, this.$baseUrl.fileslist, {
            data: {
              bucket: localStorage.getItem('enterprise_id'),
              path: this.mydata.path + '/',
              name: queryString,
              page: this.currentPage,
              limit: 100,
            }
          })
          .then((res) => {
            if (res.data.code == 0) {
              this.tableData = res.data.data.files
              this.total = this.tableData.length;
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
              });
            }
          })
    },

    fileslist() {
      this.$tools
          .asyncPost(this, this.$baseUrl.fileseplist, {
            data: {
              bucket: localStorage.getItem('enterprise_id'),
              path: this.path
            }
          })
          .then((res) => {
            if (res.data.code == 0) {
              this.treedata = res.data.data
              if (res.data.data.length != 0) {
                this.permisdatil(this.treedata[0])
                this.$nextTick(() => {
                  if (this.path == '/pic') {
                    this.$refs.treepic.setCurrentKey(this.treedata[0].id);
                  } else {
                    this.$refs.treevideo.setCurrentKey(this.treedata[0].id);
                  }
                });
              } else {
                this.tableData = []
                this.total = 0;
              }
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
              });
            }
          })
          .catch((data) => {

          });
    },
    filesinfo() {
      this.$tools.asyncPost(this, this.$baseUrl.filesinfo, {
        data: {
          bucket: localStorage.getItem('enterprise_id')
        }
      })
          .then((res) => {
            if (res.data.code == 0) {
              this.ncitem = res.data.data
              this.residue = res.data.data.quota - res.data.data.size
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
              });
            }
          })
          .catch((data) => {

          });
    },
    permisdatil(item) {
      this.currentNodekey = item.path
      this.mydata = item
      this.loading = true;
      this.$tools
          .asyncPost(this, this.$baseUrl.fileslist, {
            data: {
              bucket: localStorage.getItem('enterprise_id'),
              path: item.path + '/',
              page: this.currentPage,
              limit: 100,
            }
          })
          .then((res) => {
            if (res.data.code == 0) {
              if (res.data.data.files != null) {
                var str = []
                res.data.data.files.forEach((item, index) => {
                  if (item.dir == false) {
                    item.size = this.getSize(item.size)
                    this.$set(item, 'imgtype', item.name.split('.').pop())
                    this.$set(item, 'checkend', false)
                    if (this.path == '/video') {
                      this.$set(item, 'thumbnail', '')
                    }
                    str.push(item)
                  }

                })
                this.tableData = str
                this.total = str.length;
              } else {
                this.tableData = []
                this.total = 0;
              }
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
              });
            }
            this.loading = false;
          })
          .catch((data) => {

          });
    },

    // calculateTableHeight() {
    //     // 根据视图高度计算表格高度的逻辑
    //     this.tabmaxheight = window.innerHeight - 260; // 示例：表格高度为窗口高度减去
    //     this.treewidth = window.innerWidth - 288 + 'px'
    // },
    scroll() {
      let con = document.getElementById('con1')
      con.style.marginTop = '-34px';
      this.animate = !this.animate;
      var that = this; // 在异步函数中会出现this的偏移问题，此处一定要先保存好this的指向
      setTimeout(function () {
        that.items.push(that.items[0]);
        that.items.shift();
        con.style.marginTop = '0px';
        that.animate = !that.animate;  // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
        this.timie = null
      }, 1000)
    },
    handleSizeChange: function (size) {
      this.pagesize = size; //每页下拉显示数据
      this.getList2();
    },
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage; //点击第几页
      this.getList2();
    },
    //点击大纲
    changeContents(contents) {
      if(this.activeName == 1 ){
        this.$nextTick(() => {
          this.postForm2.contents_id = contents.contents_id
          this.getList2()
        })
      }
    }
  },
  beforeDestroy() {
    // clearInterval(this.timie);
    // this.timie = null;
    // window.removeEventListener('resize', this.calculateTableHeight);
  },
}
</script>
<style scoped lang="less" src="./index.less"></style>